import React from "react";
import { motion } from "framer-motion";

// Botón secundario para volver
const SecondaryButton = ({ children, onClick }) => (
    <motion.button
        type="button"
        onClick={onClick}
        className="px-8 py-3 font-bold text-lg rounded-lg bg-transparent border-2 border-yellow-500/50 text-yellow-400 hover:bg-yellow-500/10 transition-all duration-300"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
    >
        {children}
    </motion.button>
);

const SorteoPrivacyPolicy = ({ onBack }) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="relative z-10 w-full max-w-4xl mx-auto px-4 py-8"
        >
            <div className="backdrop-blur-md bg-white/10 rounded-2xl p-6 md:p-8 shadow-2xl max-h-[85vh] overflow-hidden flex flex-col">
                {/* Header */}
                <div className="text-center mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-yellow-400 mb-2">
                        🔒 Política de Privacidad del Sorteo
                    </h1>
                    <p className="text-white/60 text-sm">
                        Última actualización: Diciembre 2024
                    </p>
                </div>

                {/* Contenido con scroll */}
                <div className="text-white/90 space-y-4 text-sm leading-relaxed overflow-y-auto flex-1 pr-2">
                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">1. Responsable del tratamiento</h2>
                        <p>El responsable es el equipo de <strong className="text-white">Zaquiel Comic</strong>.</p>
                        <p className="mt-1">Contacto: <span className="text-yellow-400">contacto@zaquielcomic.es</span></p>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">2. Datos recopilados</h2>
                        <ul className="list-disc list-inside space-y-1 ml-4 text-white/80">
                            <li>Correo electrónico universitario (@alumnos.uemc.es)</li>
                            <li>Sexo, edad y código postal</li>
                            <li>Preferencias y opiniones sobre el cómic</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">3. Finalidad</h2>
                        <ul className="list-disc list-inside space-y-1 ml-4 text-white/80">
                            <li>Gestionar tu participación en el sorteo</li>
                            <li>Contactar a los ganadores</li>
                            <li>Evitar participaciones duplicadas</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">4. Base legal</h2>
                        <p>Tratamiento basado en tu <strong className="text-white">consentimiento expreso</strong>.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">5. Conservación</h2>
                        <p><strong>Email:</strong> hasta finalización del sorteo. <strong>Opiniones:</strong> anonimizadas.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">6. Seguridad</h2>
                        <p>Comunicaciones cifradas (HTTPS), acceso restringido, almacenamiento seguro.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">7. Tus derechos</h2>
                        <p>Acceso, rectificación, supresión, oposición. Contacto: <span className="text-yellow-400">contacto@zaquielcomic.es</span></p>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">8. Reclamaciones</h2>
                        <p>Puedes presentar reclamación ante la <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:underline">AEPD</a>.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-bold text-yellow-400/90 mb-2">9. Bases del sorteo</h2>
                        <ul className="list-disc list-inside space-y-1 ml-4 text-white/80">
                            <li>Solo alumnos UEMC con correo @alumnos.uemc.es</li>
                            <li>Cada capítulo una sola vez por participante</li>
                            <li>Cada valoración = una participación</li>
                        </ul>
                    </section>
                </div>

                {/* Botón volver */}
                <div className="text-center mt-4 pt-4 border-t border-white/10">
                    <SecondaryButton onClick={onBack}>
                        ← Volver
                    </SecondaryButton>
                </div>
            </div>
        </motion.div>
    );
};

export default SorteoPrivacyPolicy;
